/**
 * Fanta colors from
 * https://chegg.invisionapp.com/d/main?origin=v7#/console/18294963/380877492/preview?scrollOffset=0
 */
var colors;

(function (colors) {
  colors["cheggOrange"] = "#eb7100";
  colors["orangeDark"] = "#e45800";
  colors["errorRed"] = "#e22f22";
  colors["teal"] = "#229d9e";
  colors["mustard"] = "#f7ca59";
  colors["coral"] = "#fa5f4a";
  colors["royal"] = "#515bad";
  colors["sky"] = "#2c9fd0";
  colors["link"] = "#00799e";
  colors["tealMedium"] = "#9fdbdc";
  colors["mustardMedium"] = "#fcdeab";
  colors["coralMedium"] = "#fcc3b8";
  colors["royalMedium"] = "#c0d7fc";
  colors["skyMedium"] = "#95d4ef";
  colors["tealLight"] = "#c9eded";
  colors["mustardLight"] = "#fdf0d9";
  colors["coralLight"] = "#fee1dc";
  colors["royalLight"] = "#dfebfd";
  colors["skyLight"] = "#c9e9f6";
  colors["tealXlight"] = "#eaf8f8";
  colors["mustardXlight"] = "#fef8ed";
  colors["coralXlight"] = "#fff3f2";
  colors["royalXlight"] = "#eff5fe";
  colors["skyXlight"] = "#eef8fc";
  colors["dark"] = "#222222";
  colors["grey"] = "#767676";
  colors["greyMedium"] = "#999999";
  colors["greyLight"] = "#e7e7e7";
  colors["greyMedlight"] = "#cccccc";
  colors["greyXlight"] = "#f5f5f5";
  colors["white"] = "#ffffff";
  colors["transparent"] = "transparent";
  colors["grey050"] = "#fbfafb";
  colors["grey100"] = "#eeeef1";
  colors["grey200"] = "#e2e1e6";
  colors["grey300"] = "#cac8d1";
  colors["grey400"] = "#b2afbb";
  colors["grey500"] = "#928e9f";
  colors["grey600"] = "#747283";
  colors["grey700"] = "#534f63";
  colors["grey800"] = "#474358";
  colors["grey900"] = "#302c41";
  colors["grey950"] = "#242035";
  colors["manila100"] = "#fef4ed";
  colors["manila200"] = "#fbe1cb";
  colors["manila300"] = "#ffd6b3";
  colors["manila400"] = "#ffc999";
  colors["violet050"] = "#f6f5ff";
  colors["violet100"] = "#e2dfff";
  colors["violet200"] = "#cfc8ff";
  colors["violet300"] = "#bdb2fe";
  colors["violet400"] = "#9b86f7";
  colors["violet500"] = "#6e50e2";
  colors["violet600"] = "#6041d9";
  colors["violet700"] = "#4727c3";
  colors["violet800"] = "#341c8d";
  colors["violet900"] = "#201258";
  colors["midnight100"] = "#eef0fd";
  colors["midnight200"] = "#e0dff3";
  colors["midnight300"] = "#cfcfe9";
  colors["midnight400"] = "#aeb1d6";
  colors["midnight500"] = "#8b91c1";
  colors["midnight600"] = "#515bad";
  colors["midnight700"] = "#363c73";
  colors["yellow100"] = "#fffce6";
  colors["yellow700"] = "#b85900";
  colors["red100"] = "#ffe0e0";
  colors["red700"] = "#bd1e1e";
  colors["green100"] = "#e0ffe0";
  colors["green700"] = "#1a8215";
  colors["blue100"] = "#e0eaff";
  colors["blue700"] = "#1f54c0";
  colors["solar050"] = "#ffffe6";
  colors["solar100"] = "#fffce6";
  colors["solar300"] = "#fff78a";
  colors["solar400"] = "#f7ca59";
  colors["solar500"] = "#f2c71b";
  colors["solar700"] = "#c68216";
  colors["solar900"] = "#ad6313";
  colors["cardinal050"] = "#ffe7e6";
  colors["cardinal300"] = "#ffa49b";
  colors["cardinal400"] = "#fa5f4a";
  colors["cardinal500"] = "#ff665a";
  colors["cardinal700"] = "#d9323d";
  colors["cardinal900"] = "#b31b3d";
  colors["leaf400"] = "#2ca774";
  colors["sky050"] = "#e6f5ff";
  colors["sky300"] = "#77c7ff";
  colors["sky400"] = "#2c9fd0";
  colors["sky500"] = "#35a3ff";
  colors["sky700"] = "#0173ce";
  colors["sky900"] = "#005bad";
  colors["amethyst400"] = "#8945c4";
  colors["deepSea600"] = "#4945c4";
  colors["orange050"] = "#fff6f0";
  colors["orange100"] = "#ffeee1";
  colors["orange200"] = "#ffe6d2";
  colors["orange300"] = "#ffddc3";
  colors["orange400"] = "#ffc496";
  colors["orange500"] = "#ffab69";
  colors["orange600"] = "#f9923c";
  colors["orange700"] = "#f3821e";
  colors["orange800"] = "#eb7100";
  colors["orange900"] = "#d15b00";
  colors["mint050"] = "#e6fff8";
  colors["mint300"] = "#83ffd5";
  colors["mint500"] = "#39e4aa";
  colors["mint700"] = "#29a47a";
  colors["mint900"] = "#218463";
  colors["lavender050"] = "#ffecff";
  colors["lavender300"] = "#f9b3ff";
  colors["lavender500"] = "#d572de";
  colors["lavender700"] = "#a551bc";
  colors["lavender900"] = "#733595";
  colors["walnut050"] = "#f3eae6";
  colors["walnut300"] = "#e0cabf";
  colors["walnut500"] = "#be9a86";
  colors["walnut700"] = "#976b4d";
  colors["walnut900"] = "#7a4b26";
})(colors || (colors = {}));

export default colors;